/**
 * useLiveNotificationTap (web) — rien : le web ne reçoit pas de notification à toucher, comme
 * l'ancien live, qui ne montait `NotificationSubscriptionHandler` qu'en natif.
 */
import { type LiveTapSession } from "./liveNotificationTap"
import { type LiveChatChannel } from "./useLiveChat"

export function useLiveNotificationTap(session: LiveTapSession | null, onOpenChat: (channel: LiveChatChannel) => void) {
    void session
    void onOpenChat
}
